export const ADD_QUESTIONS = 'ADD_QUESTIONS'
export const DELETE_QUESTIONS = 'DELETE_QUESTIONS'
export const EDIT_QUESTIONS = 'EDIT_QUESTIONS'
export const FETCH_QUESTIONS = 'FETCH_QUESTIONS'
export const ADD_QUESTION_SUCCESS = 'ADD_QUESTION_SUCCESS'
export const ADD_QUESTION_FAILURE = 'ADD_QUESTION_FAILURE'
